import NotificationButton from '@/core/components/NotificationButton/NotificationButton';

export default NotificationButton;
